// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__j8EG_","newExpiryDate":"styles_newExpiryDate__3HqWh","footer":"styles_footer__3Abqd"};